import React, { useEffect, useLayoutEffect, useRef, useState } from 'react';
import './organizeYourselfSection.scss';
import { ReactComponent as CoinStackPath } from "./components/CoinStackPath.svg";
import { ReactComponent as CoinStackPathAdaptive } from "./components/CoinStackPathAdaptive.svg";
import { ReactComponent as CoinStackLeft } from "./components/CoinStackLeft.svg";
import { ReactComponent as CoinStackRight } from "./components/CoinStackRight.svg";
import { ReactComponent as FolderImage } from "./components/FolderImage.svg";
import { ReactComponent as SpeakerImage } from "./components/SpeakerImage.svg";
import { gsap } from "gsap";
import MotionPathPlugin from "gsap/MotionPathPlugin";

gsap.registerPlugin(MotionPathPlugin);

const OrganizeYourselfSection = () => {
	const [width, setWidth] = useState(window.innerWidth);
	const coinStackLeftRef = useRef<any>(null);
	const coinStackRightRef = useRef<any>(null);
	
	useLayoutEffect(() => {
		const timeline = gsap.timeline({ repeat: -1 });
		const init = () => {
			const organizeYourselfPathLeft = document.querySelector(".organize-yourself-path-left");
			const organizeYourselfPathRight = document.querySelector(".organize-yourself-path-right");
			
			if (organizeYourselfPathLeft && organizeYourselfPathRight && coinStackLeftRef.current && coinStackRightRef.current) {
				if (timeline) {
					timeline
					.set(coinStackLeftRef.current, { opacity: 1 })
					 .to(coinStackLeftRef.current, {
						 duration: 3,
						 ease: "none",
						 motionPath: {
							 path: "#organize-yourself-path-left",
							 align: "#organize-yourself-path-left",
							 alignOrigin: [0.5, 0.5],
							 autoRotate: true,
						 },
						 scale: 1.5,
						 onComplete: () => {
							 gsap.set(coinStackLeftRef.current, { opacity: 0, duration: 0.5 });
							 gsap.set(coinStackRightRef.current, { opacity: 0, duration: 0.5 });
							 //gsap.to(coinStackLeftRef.current, { y: "+=20"});
						 },
					 })
					 .set(coinStackRightRef.current, { opacity: 1 })
					 .to(coinStackRightRef.current, {
						 duration: 3,
						 ease: "none",
						 motionPath: {
							 path: "#organize-yourself-path-right",
							 align: "#organize-yourself-path-right",
							 alignOrigin: [0.5, 0.5],
							 autoRotate: true,
						 },
						 scale: 1.5,
						 onComplete: () => {
							 gsap.set(coinStackRightRef.current, { opacity: 0, duration: 0.5 });
							 gsap.set(coinStackLeftRef.current, { opacity: 0, duration: 0.5 });
						 },
					 });
				}
			}
			
		}
		
		init();
		
		return () => {
			timeline.kill();
		}
		
	}, []);
	
	const updateDimensions = () => {
		setWidth(window.innerWidth);
	}
	useEffect(() => {
		window.addEventListener("resize", updateDimensions);
		return () => window.removeEventListener("resize", updateDimensions);
	}, []);
	
	return (
		<div className="organizeYourself">
			<div className="stars"></div>
			<div className="stars2"></div>
			<div className="stars3"></div>
			{
				width > 1023 ? (
					<div className="organizeYourself__content">
						<div className="organizeYourself__content_data">
							<h2>Organize yourself in the crypto space</h2>
							<span>
								Our team discovers and structures up-to-date information on profitable and
								promising crypto projects. We will find and showcase what truly deserves
								your time and effort. No more following endless sources of content, NFD Platform
								will provide you with all the relevant data and tools you need.
							</span>
							<h4>The platform is free for everyone, ....</h4>
						</div>
						<div className="organizeYourself__content_image">
							<CoinStackPath />
							<CoinStackLeft ref={coinStackLeftRef} id="organize-yourself-coin-stack-left" className="coinStack" />
							<CoinStackRight ref={coinStackRightRef} id="organize-yourself-coin-stack-right" className="coinStack" />
							<FolderImage />
							<SpeakerImage />
						</div>
					</div>
				) : (
					<div className="organizeYourself__content">
						<div className="organizeYourself__content_data">
							<h2>Organize yourself in the crypto space</h2>
							<div className="organizeYourself__content_data_image">
								{
									width < 425 ? (
										<CoinStackPathAdaptive />
										) : (
											<CoinStackPath />
										)
								}
								<CoinStackLeft ref={coinStackLeftRef} id="organize-yourself-coin-stack-left" className="coinStack" />
								<CoinStackRight ref={coinStackRightRef} id="organize-yourself-coin-stack-right" className="coinStack" />
								<FolderImage />
								<SpeakerImage />
							</div>
							<span>
								Our team discovers and structures up-to-date information on profitable and
								promising crypto projects. We will find and showcase what truly deserves
								your time and effort. No more following endless sources of content, NFD Platform
								will provide you with all the relevant data and tools you need.
							</span>
							<h4>The platform is free for everyone, ....</h4>
						</div>
					</div>
				)
			}
		</div>
	);
};

export default OrganizeYourselfSection;